export const parseAreaMobileStr = (value) => {
  const input = value || '';
  const matchArr = input.match(/^([^-]+)-(.*)$/) || [];
  return { areaCode: matchArr[1] || '', mobileStr: matchArr[2] || '' };
};

export const stringifyAreaMobile = (code, mobile) => {
  return `${code || ''}-${mobile || ''}`;
};

// 格式化展示
// +86-17777 => (+86)17777
export const formatAreaMobileStr = (value) => {
  if (value) {
    return value.replace(/^([^-]+)-(.*)$/, '($1)$2');
  }
  return '—';
};

/**
 * v2.11 校验手机号格式
 * +86 开头的 ，需要满足 以1开头的 11位数字
 * 其他区号开头的，需要满足 3~20 位数字
 * */
export const validateMobileValue = (value) => {
  const { areaCode, mobileStr } = parseAreaMobileStr(value);
  if (mobileStr) {
    return ['86', '+86'].includes(areaCode)
      ? /^1\d{10}$/.test(mobileStr)
      : /^\d{3,20}$/.test(mobileStr);
  }
  return true;
};
